import {Link} from '@amzn/awsui-components-react'
import React from 'react';
import {getAcPageUrl, getDynamicExecutionPageUrl, getExclusionGroupPageUrl, getIapPageUrl, getIogPageUrl, getRuleGroupPageUrl, getWorkflowHistoryPageUrl} from '../backend/internalUrls';
import {WorkflowExecutionStatus} from '../backend/model';
import WorkflowStatusIndicator from './workflow/WorkflowStatusIndicator';
import { RULE_DELIMITER } from '../common/constants';

interface IogLinkProps {
    iogId: string;
}

export const IogLink: React.FC<IogLinkProps> = (props): JSX.Element => {
    return <Link href={getIogPageUrl(props.iogId)}>{props.iogId}</Link>
}

interface IoglLinkProps {
    iogId: string;
    fcId: string;
}

export const IoglLink: React.FC<IoglLinkProps> = (props): JSX.Element => {
    return <Link href={getIogPageUrl(props.iogId, props.fcId)}>{props.fcId}</Link>
}

interface IapLinkProps {
    iapId: string;
    fnsku?: string;
}

export const IapLink: React.FC<IapLinkProps> = (props): JSX.Element => {
    return <Link href={getIapPageUrl(props.iapId, props.fnsku)}>{props.iapId}</Link>
}

interface AcLinkProps {
    ac: string;
    fnsku?: string;
}

export const AcLink: React.FC<AcLinkProps> = (props): JSX.Element => {
    return <Link href={
        getAcPageUrl(props.ac, undefined, undefined, undefined, undefined, props.fnsku)
    }>{props.ac}</Link>
}

interface RuleGroupLinkProps {
    ruleGroupName: string;
}

export const RuleGroupLink: React.FC<RuleGroupLinkProps> = (props): JSX.Element => {
    return <Link href={
        getRuleGroupPageUrl(props.ruleGroupName)
    }>{props.ruleGroupName}</Link>
}

interface RuleLinkProps {
    ruleGroupName: string;
    ruleName: string;
}

export const RuleLink: React.FC<RuleLinkProps> = (props): JSX.Element => {
    return <Link href={
        getRuleGroupPageUrl(props.ruleGroupName, props.ruleName)
    }>{props.ruleName}</Link>
}

interface RuleLongLinkProps {
    ruleGroupRuleName: string;
}

export const RuleLongLink: React.FC<RuleLongLinkProps> = (props): JSX.Element => {
    const ruleGroupName = props.ruleGroupRuleName.substring(0, props.ruleGroupRuleName.indexOf(RULE_DELIMITER))
    const ruleName = props.ruleGroupRuleName.substring(props.ruleGroupRuleName.indexOf(RULE_DELIMITER) + 1)
    return <Link href={
        getRuleGroupPageUrl(ruleGroupName, ruleName)
    }>{props.ruleGroupRuleName}</Link>
}

interface RuleListLinkProps {
    rules: string[];
}

export const RuleListLink: React.FC<RuleListLinkProps> = (props): JSX.Element => {
    return (
        <ul>
            {props.rules.map((rule) => <li key={rule}><RuleLongLink ruleGroupRuleName={rule} /></li>)}
        </ul>
    )
}

interface ExclusionGroupLinkProps {
    exclusionGroupName: string;
}

export const ExclusionGroupLink: React.FC<ExclusionGroupLinkProps> = (props): JSX.Element => {
    return <Link href={
        getExclusionGroupPageUrl(props.exclusionGroupName)
    }>{props.exclusionGroupName}</Link>
}

interface WorkflowHistoryExecutionIdProps {
    executionId: string
}

export const WorkflowHistoryExecutionIdLink: React.FC<WorkflowHistoryExecutionIdProps> = (props): JSX.Element => {
    return <Link href={
        getWorkflowHistoryPageUrl(props.executionId)
    }>{props.executionId}</Link>
}

interface WorkflowHistoryWorkflowNameProps {
    workflowName: string
}

export const WorkflowHistoryWorkflowNameLink: React.FC<WorkflowHistoryWorkflowNameProps> = (props): JSX.Element => {
    return <Link href={
        getWorkflowHistoryPageUrl(undefined, 1, props.workflowName)
    }>{props.workflowName}</Link>
}

interface WorkflowHistoryStatusProps {
    status: WorkflowExecutionStatus
}

export const WorkflowHistoryStatusLink: React.FC<WorkflowHistoryStatusProps> = (props): JSX.Element => {
    return <Link href={
        getWorkflowHistoryPageUrl(undefined, 1, undefined, props.status)
    }><WorkflowStatusIndicator status={props.status}/></Link>
}

interface WorkflowHistoryRequesterProps {
    requester: string
}

export const WorkflowHistoryRequesterLink: React.FC<WorkflowHistoryRequesterProps> = (props): JSX.Element => {
    return <Link href={
        getWorkflowHistoryPageUrl(undefined, 1, undefined, undefined, props.requester)
    }>{props.requester}</Link>
}

export const DynamicExecutionIdLink: React.FC<WorkflowHistoryExecutionIdProps> = (props): JSX.Element => {
    return <Link href={
        getDynamicExecutionPageUrl(props.executionId)
    }>{props.executionId}</Link>
}
